export default __webpack_public_path__ + "static/media/vault.9872c08f.webp";